import React, { Component } from 'react';
import injectSheet from 'react-jss';
import ReactQuill from 'react-quill';
import classNames from 'classnames';

const styles = {
  noteContainer: {
    position: 'fixed',
    bottom: 0,
    right: 0,
    width: '37.5rem',
    'float': 'right',
    boxShadow: '1px 3px 10px -1px rgba(87,73,87,0.49)',
    height: '21rem',
    background: '#FFFFFF',
  },
  headerWrapper: {
    background: '#34A5DA',
    color: '#FFFFFF',
    // boxShadow: '1px 3px 10px -1px rgba(87,73,87,0.49)',
    borderTopLeftRadius: '5px',
    borderTopRightRadius: '5px',
    lineHeight: '2rem',
    height: '2rem',
  },
  textArea: {
    maxHeight: '19.63rem',
    minHeight: '19.63rem',
    // border: '1px solid #ced4da',
    boxShadow: '1px 3px 10px -1px rgba(87,73,87,0.49)',
    position: 'absolute',
    // width: '100%',
    background: '#FFFFFF',
    // borderRadius: '0.3125rem',
    '& > .ql-toolbar': {
      position: 'absolute',
      border: 'none',
      zIndex: 9,
      boxShadow: '1px 3px 10px -1px rgba(87,73,87,0.49)',
      left: '1rem',
      bottom: 0,
      width: '371px',
      borderRadius: '0.3125rem',
      marginBottom: '1rem',
      '& > .ql-formats .ql-picker.ql-expanded .ql-picker-options': {
        marginTop: '-207px',
      },
    },
    '& > .ql-container': {
      position: 'absolute',
      border: 'none',
      width: '37rem',
      minHeight: '14.63rem',
      maxHeight: '14.63rem',
    },
  },
  title: {
    display: 'inline-block',
    marginLeft: '1rem',
  },
  iconWrapper: {
    display: 'inline-block',
    'float': 'right',
    marginRight: '1rem',
  },
  minimizeHeight: {
    height: '2rem',
  },
  displayNone: {
    display: 'none',
  },
};


class NoteTextBox extends Component {
  state = {
    hide: false,
  }

  handleClick = () => {
    // TODO: hiding note and opening causing bug which remove the input texts, for now dont let the user to hide the input box.
    // this.setState({
    //   hide: !this.state.hide,
    // });
  }

  render() {
    const {
      classes, value, onChange, title,
    } = this.props;

    return (
      <div className={classNames(classes.noteContainer, {
        [classes.minimizeHeight]: this.state.hide,
      })}
      >
        <div className={classes.headerWrapper} onClick={this.handleClick}>
          <span className={classes.title}>{title}</span>
          <span className={classes.iconWrapper}><i className={this.state.hide ? 'icon-collapse' : 'icon-expand'} /></span>
        </div>
        <ReactQuill
          id="note"
          value={value || ''}
          theme="snow"
          onChange={onChange}
          className={classNames(classes.textArea, {
            [classes.displayNone]: this.state.hide,
          })}
          name="note"
          placeholder="Write down anything you want from the session to save for posterity..."
        />
      </div>
    );
  }
}

export default injectSheet(styles)(NoteTextBox);



// WEBPACK FOOTER //
// ./src/components/NoteTextBox.js